'use strict'

if(document.querySelector('.js-useSlider')){
    var mySwiper = new Swiper ('.js-useSlider .swiper-container', {
        direction: 'horizontal',
        loop: true,
        slidesPerView: 3,
        breakpoints: {
            1024: {
                slidesPerView: 1,
                spaceBetween: 10
            }
        },
        navigation: {
            nextEl: '.useful-swiper-next',
            prevEl: '.useful-swiper-prev',
        },

    })
}
if(document.querySelector('.js-newsSlider')){
    var mySwiper = new Swiper ('.js-newsSlider .swiper-container', {
        direction: 'horizontal',
        loop: true,
        slidesPerView: 2,
        spaceBetween: 40,
        breakpoints: {
            768: {
                slidesPerView: 1,
                spaceBetween: 10
            }
        },
        navigation: {
            nextEl: '.news-swiper-next',
            prevEl: '.news-swiper-prev',
        },

    })
}
if(document.querySelector('.js-mainSlider')){
    var mySwiper = new Swiper ('.js-mainSlider .swiper-container', {
        direction: 'horizontal',
        loop: true,

        navigation: {
            nextEl: '.main-swiper-next',
            prevEl: '.main-swiper-prev',
        },

    })
}

if(window.innerWidth < 1280){
    let menu_toggle = new mobile_menu('aside nav', "open_mob_toggle");
}
var upButton = document.querySelector('a.up');
window.addEventListener('scroll', function() {
    if (document.body.scrollTop > 100 || document.documentElement.scrollTop > 100) {
        upButton.style.display = 'flex';
    } else {
        upButton.style.display = 'none';
    }
});
